export const ISSUE_DISCOVERY = "ISSUE_DISCOVERY";

export const ticketsPhases = Object.freeze({
    [ISSUE_DISCOVERY]: {
        title: "Finding Issue",
        fillColor: "#0878E9",
    },
    PROBLEM_CONFIRMATION: {
        title: "Discovering Problem",
        fillColor: "#FBBF27",
    },
    SOLUTION_DELIVERY: {
        title: "Fixing Issue",
        fillColor: "#25BB87",
    },
});

/**
 * Colours for the global categories a custom ticket status can map to. The
 * three phase-backed categories reuse the phase colours above so a custom
 * status never looks out of place beside the phase it belongs to.
 */
export const globalStatusCategories = Object.freeze({
    FINDING_ISSUE: {
        title: "Finding Issue",
        fillColor: "#0878E9",
    },
    DISCOVERING_PROBLEM: {
        title: "Discovering Problem",
        fillColor: "#FBBF27",
    },
    FIXING_ISSUE: {
        title: "Fixing Issue",
        fillColor: "#25BB87",
    },
    SOLVED: {
        title: "Solved",
        fillColor: "#5A57D4",
    },
});
